import { render, staticRenderFns } from "./editTeamMapping.vue?vue&type=template&id=5611f4e8"
import script from "./editTeamMapping.vue?vue&type=script&lang=js"
export * from "./editTeamMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports